import AxiosAPI from "./AxiosAPI";

export const fetchMenusTransaction = async () => {
  try {
    const response = await AxiosAPI.get("setup/transactiontypes");
    // console.log(response.data)
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};